export default __webpack_public_path__ + "static/media/european-union.886314b7.svg";